// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box.comment-dialog {
  width: 100% !important;
  max-width: 800px;
  min-width: 500px;
  padding: 0;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  border-radius: 22px;
  overflow: hidden;
}
.box.comment-dialog .box-wrap {
  padding: 0;
}

.box {
  max-width: 600px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  border-radius: 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: 100% 90%;
  background-position: top center;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: transparent;
  position: relative;
  z-index: 2;
}

.dialog-content {
  padding: 24px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.popuptitle {
  text-align: left;
  font-size: 20px !important;
  padding-left: 0;
  padding-right: 0;
  flex: 1;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
}

.box:after {
  content: none;
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
  box-shadow: none !important;
}
.des-box i {
  color: #212427 !important;
}

.close-button {
  color: #666;
}

@media (max-width: 640px) {
  .box.comment-dialog {
    max-width: 100%;
    min-width: auto;
    border-radius: 16px;
  }
  .dialog-content {
    padding: 16px;
  }
}
.des-box:after {
  content: "";
  width: 200%;
  height: 150vh;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: -100px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 80px 0px;
  display: none;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-button {
  position: absolute;
  top: 0px;
  right: 0px;
  color: #666;
  z-index: 20;
}
.close-button mat-icon {
  color: #666;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border-color: rgb(176, 190, 197);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

/* Keep ligature text on mat-icon using the icon font (descendants can inherit Open Sans from global rules) */
.box.comment-dialog mat-icon {
  font-family: "Material Icons", "Material Icons Outlined" !important;
}

.comment-owner-action-btn {
  width: 32px !important;
  height: 32px !important;
  line-height: 32px !important;
  padding: 4px !important;
}

.comment-owner-action-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  line-height: 18px !important;
}

.parent-mobile-design,
.child-mobile-design {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: nowrap;
}

.parent-mobile-design > span,
.child-mobile-design > span {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
}

.parent-mobile-design button,
.child-mobile-design button {
  flex: 0 0 auto;
}

.parent-mobile-design button > span,
.child-mobile-design button > span {
  margin-left: 2px;
  font-size: 12px;
  line-height: 1;
}

.comment-like-btn {
  width: auto !important;
  min-width: 44px !important;
  padding: 4px 6px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.comment-like-count {
  position: static;
  min-width: 0;
  max-width: none;
  height: auto;
  padding: 0;
  border-radius: 0;
  background: transparent;
  color: #000 !important;
  font-size: 12px !important;
  line-height: 1 !important;
  text-align: left;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
  transform: none;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.example-card {
  margin-bottom: 12px !important;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 8px;
  margin-bottom: 0 !important;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 768px) {
  .container {
    padding: 0px !important;
    max-height: 95vh;
    overflow-y: auto;
  }
  .box {
    max-width: calc(100vw - 20px);
    width: calc(100vw - 20px);
    padding: 0px 20px;
  }
  .close-ico {
    top: 0px;
    right: 12px;
    margin-right: 0px;
  }
  p {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  p span {
    width: 100%;
    display: block;
  }
  .parent-mobile-design,
  .child-mobile-design {
    flex-wrap: nowrap !important;
  }
  .parent-mobile-design > span,
  .child-mobile-design > span {
    width: auto !important;
    display: inline !important;
  }
}
@media (max-width: 480px) {
  .box {
    max-width: calc(100vw - 16px);
    width: calc(100vw - 16px);
    padding: 0px 16px;
  }
  .close-ico {
    top: 0px;
    right: 10px;
    margin-right: 0px;
  }
}
@media (max-width: 360px) {
  .box {
    max-width: calc(100vw - 12px);
    width: calc(100vw - 12px);
    padding: 0px 12px;
  }
  .close-ico {
    top: 0px;
    right: 8px;
    margin-right: 0px;
  }
}
@media (max-width: 768px) and (orientation: landscape) {
  .container {
    max-height: 100vh;
  }
  .box {
    max-width: calc(100vw - 24px);
    width: calc(100vw - 24px);
    padding: 0px 20px;
  }
}
.comment-guidelines-helper {
  margin: 16px 0 0 0;
  color: red;
  font-size: 14px;
  line-height: 1.5;
  display: block;
  text-align: left;
  white-space: normal;
}

.comment-guidelines-link {
  color: #1976d2 !important;
  text-decoration: underline !important;
  cursor: pointer;
  display: inline;
  transition: color 0.2s ease;
}
.comment-guidelines-link:hover {
  color: #1565c0 !important;
  text-decoration: underline;
}

:host-context(body.theme-dark) {
  /* Scrollable comments wrapper carries inline white-ish bg via mat-card defaults. */
  /* Scrollbar styling for ALL scrollable elements in dark mode. */
  /* Firefox scrollbar. */
  /* Child-comments container div (no class) inside each parent card. */
  /* Footer border (inline style="border-top: 1px solid #ddd") visible against dark surface. */
  /* Form container — always transparent, never gets a background itself. */
  /* All inputs including reply boxes and comment box. */
  /* Outer mat-card wrapper — transparent, same as modal, not a visible box. */
  /* Box 1 — parent comment box, mirrors light mode #f3f1f1. */
  /* Box 2 — child reply card, mirrors light mode #f8f8f8. */
  /* Avatar fallback (account_circle) was hardcoded to #212427 inline. */
  /* Comment owner action icons should read on dark surface. */
}
:host-context(body.theme-dark) .container,
:host-context(body.theme-dark) .box,
:host-context(body.theme-dark) .box.comment-dialog,
:host-context(body.theme-dark) .box-wrap,
:host-context(body.theme-dark) .dialog-content,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .des-box:after {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dialog-header {
  background: transparent !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dialog-content > div {
  background: #111827 !important;
}
:host-context(body.theme-dark) *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
:host-context(body.theme-dark) *::-webkit-scrollbar-track {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) *::-webkit-scrollbar-thumb {
  background: #374151 !important;
  border-radius: 4px;
}
:host-context(body.theme-dark) *::-webkit-scrollbar-thumb:hover {
  background: #4b5563 !important;
}
:host-context(body.theme-dark) *::-webkit-scrollbar-corner {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) * {
  scrollbar-color: #374151 #1f2937;
  scrollbar-width: thin;
}
:host-context(body.theme-dark) mat-card-content > div,
:host-context(body.theme-dark) mat-card > mat-card-content > div {
  background: transparent !important;
}
:host-context(body.theme-dark) .dialog-content > div[style*=border-top] {
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) h5,
:host-context(body.theme-dark) span,
:host-context(body.theme-dark) label,
:host-context(body.theme-dark) small,
:host-context(body.theme-dark) .popuptitle,
:host-context(body.theme-dark) .close-button,
:host-context(body.theme-dark) .close-button mat-icon,
:host-context(body.theme-dark) .comment-like-count {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) form,
:host-context(body.theme-dark) mat-card form {
  background: transparent !important;
}
:host-context(body.theme-dark) .input-container,
:host-context(body.theme-dark) .input-container input,
:host-context(body.theme-dark) form input,
:host-context(body.theme-dark) form input.form-control,
:host-context(body.theme-dark) input.form-control {
  background: #1f2937 !important;
  color: #f1f5f9 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 5px !important;
}
:host-context(body.theme-dark) form input.form-control:focus,
:host-context(body.theme-dark) input.form-control:focus {
  border-color: rgba(148, 163, 184, 0.7) !important;
  outline: none !important;
}
:host-context(body.theme-dark) form input.form-control::placeholder,
:host-context(body.theme-dark) input.form-control::placeholder {
  color: #64748b !important;
}
:host-context(body.theme-dark) mat-card,
:host-context(body.theme-dark) mat-card.mat-mdc-card,
:host-context(body.theme-dark) .mat-mdc-card,
:host-context(body.theme-dark) .example-card,
:host-context(body.theme-dark) .des-box > div > div mat-card,
:host-context(body.theme-dark) .des-box > div > div mat-card.mat-mdc-card,
:host-context(body.theme-dark) .des-box > div > div mat-card.example-card {
  background: transparent !important;
  color: #e2e8f0 !important;
  --mdc-elevated-card-container-color: transparent !important;
  --mdc-outlined-card-container-color: transparent !important;
  --mat-card-subtitle-text-color: #94a3b8 !important;
  border: none !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .parent-comment-box {
  background: #1e293b !important;
  border-radius: 6px;
}
:host-context(body.theme-dark) .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment,
:host-context(body.theme-dark) mat-card.example-card.child-comment {
  background: #273548 !important;
  --mdc-elevated-card-container-color: #273548 !important;
  --mdc-outlined-card-container-color: #273548 !important;
  border: none !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) mat-card-content,
:host-context(body.theme-dark) .mat-mdc-card-content {
  background: transparent !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .with-icon,
:host-context(body.theme-dark) .with-icon span,
:host-context(body.theme-dark) .parent-comment,
:host-context(body.theme-dark) .parent-comment-box p {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .with-icon .material-icons {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .comment-guidelines-helper {
  color: white !important;
}
:host-context(body.theme-dark) .comment-guidelines-link {
  color: pink !important;
}
:host-context(body.theme-dark) .comment-guidelines-link:hover {
  color: hotpink !important;
}
:host-context(body.theme-dark) .comment-owner-action-btn,
:host-context(body.theme-dark) .comment-owner-action-btn mat-icon {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .comment-owner-action-btn.comment-like-btn mat-icon {
  color: #ff4d4d !important;
}

/* Close button — kept in flex flow with position:relative so Material's absolutely-
   positioned internal spans (.mat-mdc-button-touch-target etc.) are contained
   inside the button, not the header. */
.dialog-header .close-button {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  z-index: auto !important;
  flex-shrink: 0 !important;
  align-self: center !important;
  margin-left: 8px !important;
  overflow: hidden !important;
  border-radius: 50% !important;
  /* clip-path guarantees ALL child content (touch-target, ripple, state-layer)
     is hard-clipped to the button circle — works on both light and dark mode. */
  clip-path: circle(50%) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/comment/comment.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AA4af;EACC,uBAAA;EACA,gBAAA;EACA,gBAAA;AA1aF;;AA6aA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;AA3aF;AA6aE;EACE,UAAA;AA3aJ;;AA+aA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,yBAAA;EACA,+BAAA;AA5aF;;AA+aA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AA5aF;;AA+aA;EACE,aAAA;AA5aF;;AA+aA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA5aF;;AA8aA;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;AA3aF;;AA6aA;EACE,aAAA;AA1aF;;AA4aA;EACE,gBAAA;EACA,uBAAA;AAzaF;AA0aE;EACE,sBAAA;AAxaJ;;AA4aA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAzaF;AAgbM;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;AA9aR;AAkbE;EACE,yBAAA;AAhbJ;;AAobA;EACE,WAAA;AAjbF;;AAobA;EACE;IACE,eAAA;IACA,eAAA;IAEA,mBAAA;EAlbF;EAqbA;IACE,aAAA;EAnbF;AACF;AAubA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AArbF;;AAwbA;EACE,yBAAA;EACA,aAAA;AArbF;;AAubA;EACE,6BAAA;AApbF;;AAsbA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAnbF;;AAqbA;EACE,WAAA;EACA,YAAA;AAlbF;;AAobA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAjbF;;AAmbA;EACE,iBAAA;AAhbF;;AAmbA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAhbF;;AAkbA;EACE,gBAAA;EACA,kBAAA;AA/aF;;AAkbA;;EAEE,yBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,8BAAA;AAhbF;;AAkbA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AA/aF;;AAibA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AA9aF;AAgbE;EACE,WAAA;AA9aJ;;AAkbA;EACE,aAAA;EACA,kBAAA;AA/aF;;AAkbA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAjbF;;AAobA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAjbF;;AAobA;EACE,gCAAA;AAjbF;;AAobA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAjbF;;AAqbA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAlbF;;AAqbA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AAlbF;;AAobA,6GAAA;AACA;EACE,mEAAA;AAjbF;;AAobA;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,uBAAA;AAjbF;;AAobA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;AAjbF;;AAobA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AAjbF;;AAobA;;EAEE,cAAA;EACA,YAAA;EACA,mBAAA;AAjbF;;AAobA;;EAEE,cAAA;AAjbF;;AAobA;;EAEE,gBAAA;EACA,eAAA;EACA,cAAA;AAjbF;;AAobA;EACE,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AAjbF;;AAobA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAjbF;;AAobA;EACE,aAAA;EACA,mBAAA;AAjbF;AAkbE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AAhbJ;;AAmbA;EACE,8BAAA;AAhbF;;AAmbA;EACE,8BAAA;EACA,aAAA;AAhbF;;AAmbA;EACE,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;AAhbF;AAkbE;EACE,aAAA;AAhbJ;;AAobA;EACE;IACE,uBAAA;IACA,gBAAA;IACA,gBAAA;EAjbF;EAobA;IACE,6BAAA;IACA,yBAAA;IACA,iBAAA;EAlbF;EAqbA;IACE,QAAA;IACA,WAAA;IACA,iBAAA;EAnbF;EAsbA;IACE,eAAA;IACA,2BAAA;EApbF;EAqbE;IACE,WAAA;IACA,cAAA;EAnbJ;EAubA;;IAEE,4BAAA;EArbF;EAwbA;;IAEE,sBAAA;IACA,0BAAA;EAtbF;AACF;AAybA;EACE;IACE,6BAAA;IACA,yBAAA;IACA,iBAAA;EAvbF;EA0bA;IACE,QAAA;IACA,WAAA;IACA,iBAAA;EAxbF;AACF;AA2bA;EACE;IACE,6BAAA;IACA,yBAAA;IACA,iBAAA;EAzbF;EA4bA;IACE,QAAA;IACA,UAAA;IACA,iBAAA;EA1bF;AACF;AA8bA;EACE;IACE,iBAAA;EA5bF;EA+bA;IACE,6BAAA;IACA,yBAAA;IACA,iBAAA;EA7bF;AACF;AAgcA;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA9bF;;AAicA;EACE,yBAAA;EACA,qCAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;AA9bF;AAgcE;EACE,yBAAA;EACA,0BAAA;AA9bJ;;AAkcA;EAmBE,mFAAA;EAKA,gEAAA;EAuBA,uBAAA;EAMA,qEAAA;EAMA,4FAAA;EAiBA,yEAAA;EAMA,sDAAA;EAuBA,4EAAA;EAiBA,4DAAA;EAMA,0DAAA;EAuBA,sEAAA;EAiBA,4DAAA;AA3lBF;AAobE;;;;;;;EAOE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlbJ;AAqbE;EACE,kCAAA;EACA,yBAAA;EACA,iDAAA;AAnbJ;AAubE;EACE,8BAAA;AArbJ;AAybE;EACE,UAAA;EACA,WAAA;AAvbJ;AA0bE;EACE,8BAAA;AAxbJ;AA2bE;EACE,8BAAA;EACA,kBAAA;AAzbJ;AA4bE;EACE,8BAAA;AA1bJ;AA6bE;EACE,8BAAA;AA3bJ;AA+bE;EACE,gCAAA;EACA,qBAAA;AA7bJ;AAicE;;EAEE,kCAAA;AA/bJ;AAmcE;EACE,sDAAA;AAjcJ;AAocE;;;;;;;;;EASE,yBAAA;AAlcJ;AAscE;;EAEE,kCAAA;AApcJ;AAwcE;;;;;EAKE,8BAAA;EACA,yBAAA;EACA,sDAAA;EACA,6BAAA;AAtcJ;AAycE;;EAEE,iDAAA;EACA,wBAAA;AAvcJ;AA0cE;;EAEE,yBAAA;AAxcJ;AA4cE;;;;;;;EAOE,kCAAA;EACA,yBAAA;EACA,2DAAA;EACA,2DAAA;EACA,kDAAA;EACA,uBAAA;EACA,2BAAA;AA1cJ;AA8cE;EACE,8BAAA;EACA,kBAAA;AA5cJ;AAgdE;;EAEE,8BAAA;EACA,uDAAA;EACA,uDAAA;EACA,uBAAA;EACA,2BAAA;AA9cJ;AAidE;;EAEE,kCAAA;EACA,yBAAA;AA/cJ;AAkdE;;;;EAIE,yBAAA;AAhdJ;AAodE;EACE,yBAAA;AAldJ;AAqdE;EACE,uBAAA;AAndJ;AAsdE;EACE,sBAAA;AApdJ;AAsdI;EACE,yBAAA;AApdN;AAydE;;EAEE,yBAAA;AAvdJ;AA0dE;EACE,yBAAA;AAxdJ;;AA4dA;;uCAAA;AAGA;EACE,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA;gFAAA;EAEA,iCAAA;AAzdF","sourcesContent":["// /* BASIC */\n\n// .Login {\n//   min-height: 77vh;\n//   position: relative;\n//   background: #efeeee !important;\n//   &:after{\n//     content: \"\";\n//     width: 100%;\n//     height: 93vh;\n//     background: #efeeee;\n//     top: 0px;\n//     left: 0px;\n//     position: absolute;\n//     z-index: -1;\n//   }\n// }\n// .banner {\n//   margin-top: 200px;\n// }\n// html {\n//   background-color: #56baed;\n// }\n// p{\n//   margin-top: 0px !important;\n// }\n// body {\n//   font-family: \"Poppins\", sans-serif;\n//   height: 100vh;\n// }\n\n// a {\n//   color: #92badd;\n//   display: inline-block;\n//   text-decoration: none;\n//   font-weight: 400;\n// }\n\n// h2 {\n//   text-align: center;\n//   font-size: 16px;\n//   font-weight: 600;\n//   text-transform: uppercase;\n//   display: inline-block;\n//   margin: 40px 8px 10px 8px;\n//   color: #cccccc;\n// }\n\n// /* STRUCTURE */\n\n// .wrapper {\n//   display: flex;\n//   align-items: center;\n//   flex-direction: column;\n//   justify-content: center;\n//   width: 100%;\n//   min-height: 100%;\n//   padding: 20px;\n// }\n\n// #formContent {\n//   -webkit-border-radius: 10px 10px 10px 10px;\n//   border-radius: 10px 10px 10px 10px;\n//   background: #fff;\n//   padding: 30px;\n//   width: 90%;\n//   max-width: 550px;\n//   position: relative;\n//   padding: 0px;\n//   -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n//   box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n//   text-align: center;\n//   border: 0.5px solid lightgrey;\n//   padding: 20px;\n//   position: absolute;\n//   top: 50%;\n//   left: 50%;\n//   transform: translate(-50%, -50%);\n//   border: 1px solid #ddd;\n//   box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n//   button {\n//     span {\n//       position: absolute;\n//       top: 4px;\n//       right: 13px;\n//       color: #212427 !important;\n//     }\n//   }\n//   form {\n//     display: flex;\n//     align-items: center;\n//   }\n// }\n\n// p {\n//   display: flex;\n//   align-items: center;\n//   justify-content: flex-start;\n//   width: 100%;\n//   > span {\n//     flex: 1;\n//     display: flex;\n//     justify-content: flex-start;\n//   }\n// }\n// form {\n//   input {\n//     flex: 1;\n//   }\n// }\n\n// #formFooter {\n//   background-color: #f6f6f6;\n//   border-top: 1px solid #dce8f1;\n//   padding: 25px;\n//   text-align: center;\n//   -webkit-border-radius: 0 0 10px 10px;\n//   border-radius: 0 0 10px 10px;\n// }\n\n// /* TABS */\n\n// h2.inactive {\n//   color: #cccccc;\n// }\n\n// h2.active {\n//   color: #0d0d0d;\n//   border-bottom: 2px solid #5fbae9;\n// }\n\n// .item.ng-star-inserted {\n//   display: flex;\n//   align-items: center;\n//   span {\n//     &:first-child {\n//       flex: 1;\n//     }\n//     &:nth-child(2) {\n//       flex: 2;\n//     }\n//     &:last-child {\n//       flex: 2;\n//     }\n//   }\n// }\n\n// /* FORM TYPOGRAPHY*/\n\n// input[type=\"button\"],\n// input[type=\"submit\"],\n// input[type=\"reset\"] {\n//   background-color: #56baed;\n//   border: none;\n//   color: white;\n//   padding: 15px 80px;\n//   text-align: center;\n//   text-decoration: none;\n//   display: inline-block;\n//   text-transform: uppercase;\n//   font-size: 13px;\n//   -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n//   box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n//   -webkit-border-radius: 5px 5px 5px 5px;\n//   border-radius: 5px 5px 5px 5px;\n//   margin: 5px 20px 40px 20px;\n//   -webkit-transition: all 0.3s ease-in-out;\n//   -moz-transition: all 0.3s ease-in-out;\n//   -ms-transition: all 0.3s ease-in-out;\n//   -o-transition: all 0.3s ease-in-out;\n//   transition: all 0.3s ease-in-out;\n// }\n\n// input[type=\"button\"]:hover,\n// input[type=\"submit\"]:hover,\n// input[type=\"reset\"]:hover {\n//   background-color: #39ace7;\n// }\n\n// input[type=\"button\"]:active,\n// input[type=\"submit\"]:active,\n// input[type=\"reset\"]:active {\n//   -moz-transform: scale(0.95);\n//   -webkit-transform: scale(0.95);\n//   -o-transform: scale(0.95);\n//   -ms-transform: scale(0.95);\n//   transform: scale(0.95);\n// }\n\n// input[type=\"text\"],\n// input[type=\"password\"] {\n//   background-color: #f6f6f6;\n//   border: none;\n//   color: #0d0d0d;\n//   padding: 15px 32px;\n//   text-align: center;\n//   text-decoration: none;\n//   display: inline-block;\n//   font-size: 16px;\n//   margin: 5px;\n//   width: 85%;\n//   border: 2px solid #f6f6f6;\n//   -webkit-transition: all 0.5s ease-in-out;\n//   -moz-transition: all 0.5s ease-in-out;\n//   -ms-transition: all 0.5s ease-in-out;\n//   -o-transition: all 0.5s ease-in-out;\n//   transition: all 0.5s ease-in-out;\n//   -webkit-border-radius: 5px 5px 5px 5px;\n//   border-radius: 5px 5px 5px 5px;\n// }\n\n// input[type=\"text\"]:focus,\n// input[type=\"password\"]:focus {\n//   background-color: #fff;\n//   border-bottom: 2px solid #5fbae9;\n// }\n\n// input[type=\"text\"]:placeholder,\n// input[type=\"password\"] {\n//   color: #cccccc;\n// }\n\n// /* ANIMATIONS */\n\n// /* Simple CSS3 Fade-in-down Animation */\n// .fadeInDown {\n//   -webkit-animation-name: fadeInDown;\n//   animation-name: fadeInDown;\n//   -webkit-animation-duration: 1s;\n//   animation-duration: 1s;\n//   -webkit-animation-fill-mode: both;\n//   animation-fill-mode: both;\n// }\n\n// @-webkit-keyframes fadeInDown {\n//   0% {\n//     opacity: 0;\n//     -webkit-transform: translate3d(0, -100%, 0);\n//     transform: translate3d(0, -100%, 0);\n//   }\n//   100% {\n//     opacity: 1;\n//     -webkit-transform: none;\n//     transform: none;\n//   }\n// }\n\n// @keyframes fadeInDown {\n//   0% {\n//     opacity: 0;\n//     -webkit-transform: translate3d(0, -100%, 0);\n//     transform: translate3d(0, -100%, 0);\n//   }\n//   100% {\n//     opacity: 1;\n//     -webkit-transform: none;\n//     transform: none;\n//   }\n// }\n\n// /* Simple CSS3 Fade-in Animation */\n// @-webkit-keyframes fadeIn {\n//   from {\n//     opacity: 0;\n//   }\n//   to {\n//     opacity: 1;\n//   }\n// }\n// @-moz-keyframes fadeIn {\n//   from {\n//     opacity: 0;\n//   }\n//   to {\n//     opacity: 1;\n//   }\n// }\n// @keyframes fadeIn {\n//   from {\n//     opacity: 0;\n//   }\n//   to {\n//     opacity: 1;\n//   }\n// }\n\n// .fadeIn {\n//   opacity: 0;\n//   -webkit-animation: fadeIn ease-in 1;\n//   -moz-animation: fadeIn ease-in 1;\n//   animation: fadeIn ease-in 1;\n\n//   -webkit-animation-fill-mode: forwards;\n//   -moz-animation-fill-mode: forwards;\n//   animation-fill-mode: forwards;\n\n//   -webkit-animation-duration: 1s;\n//   -moz-animation-duration: 1s;\n//   animation-duration: 1s;\n// }\n\n// .fadeIn.first {\n//   -webkit-animation-delay: 0.4s;\n//   -moz-animation-delay: 0.4s;\n//   animation-delay: 0.4s;\n// }\n\n// .fadeIn.second {\n//   -webkit-animation-delay: 0.6s;\n//   -moz-animation-delay: 0.6s;\n//   animation-delay: 0.6s;\n//   border: 0.5px solid lightgrey;\n// }\n\n// .fadeIn.third {\n//   -webkit-animation-delay: 0.8s;\n//   -moz-animation-delay: 0.8s;\n//   animation-delay: 0.8s;\n//   border: 0.5px solid lightgrey;\n// }\n\n// .fadeIn.fourth {\n//   -webkit-animation-delay: 1s;\n//   -moz-animation-delay: 1s;\n//   animation-delay: 1s;\n//   border: 0.5px solid lightgrey;\n// }\n\n// /* Simple CSS3 Fade-in Animation */\n// .underlineHover:after {\n//   display: block;\n//   left: 0;\n//   bottom: -10px;\n//   width: 0;\n//   height: 2px;\n//   background-color: #56baed;\n//   content: \"\";\n//   transition: width 0.2s;\n// }\n\n// .underlineHover:hover {\n//   color: #0d0d0d;\n// }\n\n// .underlineHover:hover:after {\n//   width: 100%;\n// }\n\n// /* OTHERS */\n\n// *:focus {\n//   outline: none;\n// }\n\n// #icon {\n//   width: 60%;\n// }\n\n// .mat-badge-content {\n//   background: #5ea1d8;\n// }\n\n// img {\n//   border-radius: 50%;\n// }\n\n// @media (max-width: 767px) {\n//   #formContent {\n//     padding: 20px 15px;\n//     .parent-mobile-design, .child-mobile-design{\n//       display: flex;\n//       flex-wrap: wrap;\n//       span{\n//         display: block;\n//     width: 100%;\n//     max-width: 100%;\n//     flex: unset;\n//     text-align: left;\n//       }\n//       button{\n//         display: flex;\n//         flex-direction: row;\n//       }\n//     }\n//   }\n// }\n// .with-icon {\n//   display: flex;\n//   align-items: center;\n//   height: auto;\n//   color: #212427;\n//   margin-bottom: 10px;\n//   //align-items: center;\n//   img {\n//     margin: 0px;\n//   }\n// }\n// i {\n//   color: #212427;\n// }\n\n// .img-div-left {\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n// .child-comment, .parent-comment-box{\n//   background: #f8f8f8;\n//   padding: 10px;\n//   margin-left:30px;\n//   width:calc(100% - 30px);\n//   margin-bottom: 20px;\n//   box-shadow: 0px 5px 10px rgb(100 100 111 / 9%), 0px -3px 10px rgb(100 100 111 / 9%) !important;\n//   box-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4) !important;\n// }\n// .parent-comment-box{\n//   margin-left: 0px;\n//   width: 100%;\n//   background: #f3f1f1;\n// }\n\n .container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.box.comment-dialog {\n  width: 100% !important;\n  max-width: 800px;\n  min-width: 500px;\n  // margin: 16px auto;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  border-radius: 22px;\n  overflow: hidden;\n\n  .box-wrap {\n    padding: 0;\n  }\n}\n\n.box {\n  max-width: 600px;\n  width: 100% !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  border-radius: 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n  background: transparent;\n  position: relative;\n  z-index: 2;\n}\n\n.dialog-content {\n  padding: 24px;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.popuptitle {\n  text-align: left;\n  font-size: 20px !important;\n  padding-left: 0;\n  padding-right: 0;\n  flex: 1;\n  min-width: 0;\n  white-space: normal;\n  word-break: break-word;\n}\n.box:after {\n  content: none;\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n\n.close-button {\n  color: #666;\n}\n\n@media (max-width: 640px) {\n  .box.comment-dialog {\n    max-width: 100%;\n    min-width: auto;\n    // margin: 8px;\n    border-radius: 16px;\n  }\n\n  .dialog-content {\n    padding: 16px;\n  }\n}\n\n// Removed custom comments-scroll sizing (reverting to inline height 400px)\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 150vh;\n  background: #fff;\n  border-radius: 0px !important;\n  position: absolute;\n  top: -100px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 80px 0px;\n  display: none;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  // display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-button {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  color: #666;\n  z-index: 20;\n  \n  mat-icon {\n    color: #666;\n  }\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border-color: rgb(176 190 197);\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\n/* Keep ligature text on mat-icon using the icon font (descendants can inherit Open Sans from global rules) */\n.box.comment-dialog mat-icon {\n  font-family: \"Material Icons\", \"Material Icons Outlined\" !important;\n}\n\n.comment-owner-action-btn {\n  width: 32px !important;\n  height: 32px !important;\n  line-height: 32px !important;\n  padding: 4px !important;\n}\n\n.comment-owner-action-btn mat-icon {\n  font-size: 18px !important;\n  width: 18px !important;\n  height: 18px !important;\n  line-height: 18px !important;\n}\n\n.parent-mobile-design,\n.child-mobile-design {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex-wrap: nowrap;\n}\n\n.parent-mobile-design > span,\n.child-mobile-design > span {\n  flex: 1 1 auto;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.parent-mobile-design button,\n.child-mobile-design button {\n  flex: 0 0 auto;\n}\n\n.parent-mobile-design button > span,\n.child-mobile-design button > span {\n  margin-left: 2px;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.comment-like-btn {\n  width: auto !important;\n  min-width: 44px !important;\n  padding: 4px 6px !important;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n}\n\n.comment-like-count {\n  position: static;\n  min-width: 0;\n  max-width: none;\n  height: auto;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  color: #000 !important;\n  font-size: 12px !important;\n  line-height: 1 !important;\n  text-align: left;\n  overflow: visible;\n  text-overflow: clip;\n  white-space: nowrap;\n  transform: none;\n}\n\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.example-card {\n  margin-bottom: 12px !important;\n}\n\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n}\n\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 8px;\n  margin-bottom: 0 !important;\n\n  mat-card {\n    padding: 10px;\n  }\n}\n// Mobile Responsiveness - Ensure visibility on all mobile devices\n@media (max-width: 768px) {\n  .container {\n    padding: 0px !important;\n    max-height: 95vh;\n    overflow-y: auto;\n  }\n\n  .box {\n    max-width: calc(100vw - 20px);\n    width: calc(100vw - 20px);\n    padding: 0px 20px;\n  }\n\n  .close-ico {\n    top: 0px;\n    right: 12px;\n    margin-right: 0px;\n  }\n\n  p {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    span {\n      width: 100%;\n      display: block;\n    }\n  }\n\n  .parent-mobile-design,\n  .child-mobile-design {\n    flex-wrap: nowrap !important;\n  }\n\n  .parent-mobile-design > span,\n  .child-mobile-design > span {\n    width: auto !important;\n    display: inline !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .box {\n    max-width: calc(100vw - 16px);\n    width: calc(100vw - 16px);\n    padding: 0px 16px;\n  }\n\n  .close-ico {\n    top: 0px;\n    right: 10px;\n    margin-right: 0px;\n  }\n}\n\n@media (max-width: 360px) {\n  .box {\n    max-width: calc(100vw - 12px);\n    width: calc(100vw - 12px);\n    padding: 0px 12px;\n  }\n\n  .close-ico {\n    top: 0px;\n    right: 8px;\n    margin-right: 0px;\n  }\n}\n\n// Landscape orientation support\n@media (max-width: 768px) and (orientation: landscape) {\n  .container {\n    max-height: 100vh;\n  }\n\n  .box {\n    max-width: calc(100vw - 24px);\n    width: calc(100vw - 24px);\n    padding: 0px 20px;\n  }\n}\n\n.comment-guidelines-helper {\n  margin: 16px 0 0 0;\n  color: red;\n  font-size: 14px;\n  line-height: 1.5;\n  display: block; // override global p { display: flex; ... }\n  text-align: left;\n  white-space: normal;\n}\n\n.comment-guidelines-link {\n  color: #1976d2 !important;\n  text-decoration: underline !important;\n  cursor: pointer;\n  display: inline;\n  transition: color 0.2s ease;\n\n  &:hover {\n    color: #1565c0 !important;\n    text-decoration: underline;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .container,\n  .box,\n  .box.comment-dialog,\n  .box-wrap,\n  .dialog-content,\n  .des-box,\n  .des-box:after {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dialog-header {\n    background: transparent !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Scrollable comments wrapper carries inline white-ish bg via mat-card defaults. */\n  .dialog-content > div {\n    background: #111827 !important;\n  }\n\n  /* Scrollbar styling for ALL scrollable elements in dark mode. */\n  *::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  *::-webkit-scrollbar-track {\n    background: #1f2937 !important;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    background: #374151 !important;\n    border-radius: 4px;\n  }\n\n  *::-webkit-scrollbar-thumb:hover {\n    background: #4b5563 !important;\n  }\n\n  *::-webkit-scrollbar-corner {\n    background: #1f2937 !important;\n  }\n\n  /* Firefox scrollbar. */\n  * {\n    scrollbar-color: #374151 #1f2937;\n    scrollbar-width: thin;\n  }\n\n  /* Child-comments container div (no class) inside each parent card. */\n  mat-card-content > div,\n  mat-card > mat-card-content > div {\n    background: transparent !important;\n  }\n\n  /* Footer border (inline style=\"border-top: 1px solid #ddd\") visible against dark surface. */\n  .dialog-content > div[style*=\"border-top\"] {\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  p,\n  h5,\n  span,\n  label,\n  small,\n  .popuptitle,\n  .close-button,\n  .close-button mat-icon,\n  .comment-like-count {\n    color: #e2e8f0 !important;\n  }\n\n  /* Form container — always transparent, never gets a background itself. */\n  form,\n  mat-card form {\n    background: transparent !important;\n  }\n\n  /* All inputs including reply boxes and comment box. */\n  .input-container,\n  .input-container input,\n  form input,\n  form input.form-control,\n  input.form-control {\n    background: #1f2937 !important;\n    color: #f1f5f9 !important;\n    border: 1px solid rgba(148, 163, 184, 0.35) !important;\n    border-radius: 5px !important;\n  }\n\n  form input.form-control:focus,\n  input.form-control:focus {\n    border-color: rgba(148, 163, 184, 0.7) !important;\n    outline: none !important;\n  }\n\n  form input.form-control::placeholder,\n  input.form-control::placeholder {\n    color: #64748b !important;\n  }\n\n  /* Outer mat-card wrapper — transparent, same as modal, not a visible box. */\n  mat-card,\n  mat-card.mat-mdc-card,\n  .mat-mdc-card,\n  .example-card,\n  .des-box > div > div mat-card,\n  .des-box > div > div mat-card.mat-mdc-card,\n  .des-box > div > div mat-card.example-card {\n    background: transparent !important;\n    color: #e2e8f0 !important;\n    --mdc-elevated-card-container-color: transparent !important;\n    --mdc-outlined-card-container-color: transparent !important;\n    --mat-card-subtitle-text-color: #94a3b8 !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  /* Box 1 — parent comment box, mirrors light mode #f3f1f1. */\n  .parent-comment-box {\n    background: #1e293b !important;\n    border-radius: 6px;\n  }\n\n  /* Box 2 — child reply card, mirrors light mode #f8f8f8. */\n  .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment,\n  mat-card.example-card.child-comment {\n    background: #273548 !important;\n    --mdc-elevated-card-container-color: #273548 !important;\n    --mdc-outlined-card-container-color: #273548 !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n\n  mat-card-content,\n  .mat-mdc-card-content {\n    background: transparent !important;\n    color: #e2e8f0 !important;\n  }\n\n  .with-icon,\n  .with-icon span,\n  .parent-comment,\n  .parent-comment-box p {\n    color: #e2e8f0 !important;\n  }\n\n  /* Avatar fallback (account_circle) was hardcoded to #212427 inline. */\n  .with-icon .material-icons {\n    color: #cbd5e1 !important;\n  }\n\n  .comment-guidelines-helper {\n    color: white !important;\n  }\n\n  .comment-guidelines-link {\n    color: pink !important;\n\n    &:hover {\n      color: hotpink !important;\n    }\n  }\n\n  /* Comment owner action icons should read on dark surface. */\n  .comment-owner-action-btn,\n  .comment-owner-action-btn mat-icon {\n    color: #cbd5e1 !important;\n  }\n\n  .comment-owner-action-btn.comment-like-btn mat-icon {\n    color: #ff4d4d !important;\n  }\n}\n\n/* Close button — kept in flex flow with position:relative so Material's absolutely-\n   positioned internal spans (.mat-mdc-button-touch-target etc.) are contained\n   inside the button, not the header. */\n.dialog-header .close-button {\n  position: relative !important;\n  top: auto !important;\n  right: auto !important;\n  z-index: auto !important;\n  flex-shrink: 0 !important;\n  align-self: center !important;\n  margin-left: 8px !important;\n  overflow: hidden !important;\n  border-radius: 50% !important;\n  /* clip-path guarantees ALL child content (touch-target, ripple, state-layer)\n     is hard-clipped to the button circle — works on both light and dark mode. */\n  clip-path: circle(50%) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
